import { render, staticRenderFns } from "./outcome.vue?vue&type=template&id=42515234"
import script from "./outcome.ts?vue&type=script&lang=js&external"
export * from "./outcome.ts?vue&type=script&lang=js&external"
import style0 from "./outcome.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports